import i18n from '@/lang/i18n'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { PaginatorDatasource } from '@/shared/resources/datasources/paginator/paginator-datasource'
import { mostLikelyMorphologicCodesConfigurationServices } from '@/api/resources/configuration/samples/mostLikelyMorphologicCodes/MostLikelyMorphologicCodesServices'
import { initialCrudModelBaseState, CrudModelBase } from '@/shared/models/cruds.models'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'

export const columnsDefMostLikelyMorphologicCodesGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.code'),
            field: 'code',
            width: 150,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.mostLikelyDiagnoses'),
            field: 'description',
            minWidth: 280,
            flex: 1,
            suppressSizeToFit: true
        },
        // TODO Pending to implement
        // {
        //     type: AgGridColumnType.CHECK_ICON,
        //     headerName: i18n.tc('configuration.grid.ownCode'),
        //     field: 'ownCode',
        //     minWidth: 150,
        //     suppressSizeToFit: true
        // },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 150,
            suppressSizeToFit: true
        }
    ]

export interface IContentMostLikelyMorphologicCodesGrid {
    id?: number
    code: string
    description: string
    active: boolean
    userDefined?: boolean
}
export const initialMostLikelyMorphologicCodesModalState =
    (): IContentMostLikelyMorphologicCodesGrid => ({
        id: undefined,
        code: '',
        description: '',
        active: false
    })

export type IMostLikelyMorphologicCodesGridState = CrudModelBase<IContentMostLikelyMorphologicCodesGrid>
export const initialMostLikelyMorphologicCodesGridState =
    (): IMostLikelyMorphologicCodesGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.global.samples.mostLikelyDiagnoses',
        columnsDef: columnsDefMostLikelyMorphologicCodesGrid(),
        datasource: new PaginatorDatasource(mostLikelyMorphologicCodesConfigurationServices)
    })
